import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import categoriesAndWorlds from './categoriesAndWorlds'
import makeItemsReducer from './items'
import makeAuthReducer from './auth'
import itemDetail from './itemDetail'
import messages from './messages'
import districts from './districts'
import swaps from './swaps'
import swapDetail from './swapDetail'
import newSwap from './newSwap'
import loggedUserCounts from './loggedUserCounts'
import otherUser from './otherUser'
import ui from './ui'
import cookieAccepted from './cookieAccepted'
import notificationQueue from './notificationQueue'
import attributeValues from './attributeValues'
import genereValues from './genereValues'
import wantedItems from './wantedItems'
import ownedItems from './ownedItems'
import itemsICanGet from './itemsICanGet'
import fb from './fb'
import {
  GET_ITEMS,
  GET_ITEMS_SEARCH,
  GET_OWNED_ITEMS,
  GET_ITEMS_I_CAN_GET,
  GET_INTEREST_ITEMS,
} from '../actions'

export default combineReducers({
  form: formReducer,
  auth: makeAuthReducer(),
  loggedUserCounts,
  categoriesAndWorlds,
  districts,
  wantedItems,
  ownedItems,
  itemsICanGet,
  allItems: makeItemsReducer(GET_ITEMS, {
    handleWanted: true,
    ownerDriven: true,
  }),
  interestItems: makeItemsReducer(GET_INTEREST_ITEMS, {
    handleWanted: false,
    interest: true,
  }),
  // Using in add item to search items
  searchItems: makeItemsReducer(GET_ITEMS_SEARCH, {
    handleWanted: false,
    ownerDriven: true,
  }),
  messages,
  itemDetail,
  swapDetail,
  newSwap,
  swaps,
  otherUser,
  notificationQueue,
  attributeValues,
  genereValues,
  ui,
  fb,
  cookieAccepted,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js